// Auto-dismisses info flashes after a few seconds by triggering the same
// click binding the manual × uses (lv:clear-flash + hide). Error flashes
// stay sticky — they don't get this hook. The timer resets if LiveView
// patches a new message into the same flash element.
const DISMISS_AFTER_MS = 4000;

const AutoDismissFlash = {
  mounted() {
    this.arm();
  },
  updated() {
    this.arm();
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  arm() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.el.click(), DISMISS_AFTER_MS);
  },
};

export default AutoDismissFlash;
